export const convertToTreeData = (flatData) => {
  if (!flatData) return [];

  if (flatData.children) {
    return flatData.children.map((child) => ({
      name: child.name,
      value: child.id,
      children: child.children ? convertToTreeData(child) : [],
    }));
  }

  const itemMap = {};
  flatData.forEach((item) => {
    itemMap[item.id] = {
      name: item.name,
      value: item.id,
      children: [],
    };
  });

  const treeData = [];

  flatData.forEach((item) => {
    if (item.parent_id !== null && itemMap[item.parent_id]) {
      itemMap[item.parent_id].children.push(itemMap[item.id]);
    } else {
      treeData.push(itemMap[item.id]);
    }
  });

  return treeData;
};
